export default {
	wei_zhi: "Location",
	zhu_ye: "Home",
	sheng_chan_ri_qi: "Date of production",
	ext_yan_se: "ext color",
	int_yan_se: "int color",
	wei_zhao_dao_shu_ju: "No data found",
	xuan_ze_zhu_zu_xi_fen: "Select Main Group Subdivision",
	ji_shu: "Count",
	sou_suo_jie_guo: "Search Result",
	che_liang_dai_ma: "Vehicle Code",
	che_liang_xin_xi: "Vehicle Info",
	pin_pai: "Brand",
	xing_hao_ming_cheng: "Model Name",
	sheng_chan_ri_qi_1: "productiondate",
	sheng_chan_shang: "Manufacturers",
	mo_xing: "Models",
	"SOP-EOP-": "SOP-EOP-",
	di_pan_dai_ma: "ChassisCode",
	deng_ji: "Grade",
	bian_su_qi_lei_xing: "TransmissionType",
	jia_shi_yuan_zhi_wei: "DriverPosition",
	che_liang_lei_xing: "VehicleType",
	men: "doors",
	fa_dong_ji_xing_hao: "EngineModel",
	qu_dai: "Displacement",
	gong_shuai_Kw: "PowerKw",
	ran_liao_lei_xing: "FuelType",
	qu_dong_qi_xing_hao: "DriveModel",
	"xin_10-1234567": "ZNE10-1234567",
	che_liang_sou_suo: "Vehicle Search",
	pin_pai_xing_hao: "BrandModel",
	xin_10: "ZNE10",
	xing_hao_biao_shi_hao: "Model Designation Number",
	fen_lei_bian_hao: "Classification number",
	shu_ru_zhi_shao_7_wei_OE_dai_ma: "Enter at least 7 digits of OE Code",
	di_pan_dai_ma_1: "Chassis Code",
	huan_ying: "Welcome",
	ji_de: "Remember",
	wang_ji: "forget",
	zhu_ce: "Login",
	yong_hu_ming: "Username",
	mi_ma: "Password",
	qing_shu_ru_yong_hu_ming: "please enter username",
	qing_shu_ru_zheng_que_de_yong_hu_ming: "Please enter the correct username",
	qing_shu_ru_mi_ma: "please enter password",
	qing_shu_ru_zheng_que_de_mi_ma: "Please enter the correct password",
	yong_hu_ming_huo_mi_ma_cuo_wu: "username or password error",
	fan_hui: "Back",
	bei_zhu: "Remark",
	bu: "NO",
	zhu_zu: "Main Group",
	hou_guo: "Result",
	"pin_pai_ming_cheng_/_xing_hao_ming_cheng": "BRAND NAME/MODEL NAME",
	yi_jian_sou_suo_te_ding_xiang_mu: "One-shot search for specific items",
	yi_sun_ling_jian: "Vulnerable parts",
	wai_guan_ling_jian: "Appearance parts",
	OEM_xin_xi: "OEM information",
	OEM_dai_ma: "OEM Code",
	OEM_ming_cheng: "OEM Name",
	qing_mei_su: "PNC",
	geng_huan_ling_jian_xin_xi: "Replacement part information",
	jia_ge: "Price",
	xing_xiang: "image",
	OES_pin_pai: "OES BRAND",
	OES_dai_ma: "OES CODE",
	OES_ming_cheng: "OES NAME",
	guo_jia: "COUNTRY",
	OEM_dai_ma_1: "OEM CODE",
	OEM_ming_cheng_1: "OEM NAME",
	pin_pai_1: "BRAND",
	mo_xing_1: "Model",
	ji_xiang___dai_ma: "Chassis_Code",
	kai_shi_shi_jian: "Start_time",
	jie_shu_shi_jian: "End_time",
	fa_dong_ji: "Engine",
	bian_su_qi: "Transmission",
	cha_tu: "illustration",
	OES_ling_jian_qing_dan: "OES part list",
	jian_rong_xing_hao_lie_biao: "Compatible model list",
	fa_dong_ji_he_bian_su_qi: "Engine & Transmission",
	di_pan_he_xuan_jia: "Chassis & Suspension",
	wai_bu_he_nei_bu: "Exterior & Interior",
	pan_shi_zhi_dong_pian: "Disc brake pad",
	pan_shi_zhuan_zi: "Disc roter",
	zhi_dong_ti: "Brake shoe",
	zhi_dong_zong_beng: "Brake master cylinder",
	chuan_dong_zhou_fang_chen_tao: "Drive shaft boots",
	lun_gu_zhou_cheng: "Hub bearing",
	hou_xiao_yin_qi: "Rear muffler",
	jian_zhen_qi: "Shock absorber",
	wen_ding_qi_lian_gan: "Stabilizer link",
	chuan_dong_zhou_zong_cheng: "Drive shaft assembly",
	chi_lun_chi_tiao: "Rack and pinion",
	ji_you_lv_qing_qi: "Oil Filter",
	kong_qi_lv_qing_qi: "Air cleaner",
	shui_beng: "Water pump",
	li_he_qi_gai: "Clutch cover",
	li_he_qi_pian: "Clutch disc",
	"huo_hua_sai_/_dian_re_sai": "Spark / glow plug",
	yang_qi_chuan_gan_qi: "Oxygen sensor",
	fa_dong_ji_zong_cheng: "Engine assembly",
	bian_su_qi_zong_cheng: "Transmission assembly",
	qi_dong_ji_dian_ji: "Starter motor",
	leng_que_qi_ya_suo_ji: "Cooler compressor",
	bian_ju_qi: "Torque converter",
	kong_tiao_lv_qing_qi: "Cabin filter",
	qian_men: "Front door",
	hou_men: "Rear door",
	qian_zhao_deng: "Head lamp",
	qian_bao_xian_gang: "Front bumper",
	hou_bao_xian_gang: "Rear bumper",
	wei_deng: "Tail lamp",
	hou_bo_li: "Rear glass",
	ce_shi_jing: "Side mirror",
	production_date: "production date",
	belts: "Belts",
	battery: "Battery",
	radiator: "Radiator",
	alternator: "Alternator",
	wiper: "Wiper",
	oe_name: "OE_NAME",
	start_end: "START/END",
	oem_code: "OEM Code",
	group_name_subgroup_name: "GROUP NAME/SUBGROUP NAME",
	sop: "SOP",
	eop: "EOP",
	oem_code_substitution_code: "OEM CODE/SUBSTITUTION CODE",
	oem_name_remark: "OEM NAME/REMARK",
	oes_code: "OES Code",
	model: "Model",
	grade: "Grade",
	transmission_type: "Transmission Type",
	drivers_position: "Drivers Position",
	engine_model: "Engine Model",
	displacement: "Displacement",
	windshield: "Windshield",
};
